import axios from 'axios';
import authHeader from '../auth-header';
import { API_URL } from '../API_URL';

class TransportationService{

    GetAllRoutes(){
        return axios.get(API_URL+`TransportationReserveRoute/GetAllRouteTypes`,
       
        {  headers: authHeader() })
    }
    GetAllRoutesPlans(routeId){
        return axios.get(API_URL+`TransportationReserveRoute/GetAllReservationPlansOnRouteType?RouteTypeId=${routeId}`,
       
        {  headers: authHeader() })
    }
    CancelApplicantReservation(ReservationID,ApplicantSerial){
        return axios.post(API_URL+`TransportationReserveRoute/CancelApplicantReservation?PersonTransportReservationId=${ReservationID}&UserId=${ApplicantSerial}`,
       
        {  headers: authHeader() })
    }
    GetApplicantReservation(ApplicantCode){
        return axios.get(API_URL+`TransportationReserveRoute/GetApplicantReservation?ApplicantCode=${ApplicantCode}`,
       
        {  headers: authHeader() })
    }
    PostApplicantReservation(ConfirmObj){
        return axios.post(API_URL+`TransportationReserveRoute/InsertReservation?PersonType=${ConfirmObj.PersonType}&PersonCode=${ConfirmObj.PersonCode}&PersonName=${ConfirmObj.PersonName}&RouteReservationID=${ConfirmObj.RouteReservationID}&USERID=${ConfirmObj.USERID}&ApplicantId=${ConfirmObj.ApplicantId}&Price=${ConfirmObj.Price}&Graceperiod=${ConfirmObj.Graceperiod}`,
       
        {  headers: authHeader() })
    } 
    GetPriceandAvilabelSeats(RouteTripPriceId){
        return axios.post(API_URL+`TransportationReserveRoute/SelectPriceAndAvailalbeSeatsGracePeriod?RouteTripPriceId=${RouteTripPriceId}`,
       
        {  headers: authHeader() })
    }
}

export default new TransportationService()